import "../tfdSelect/TFDSelectPrivate.css";

import React, { useState } from "react";

import { Link } from "react-router-dom";

export default function TFDSelectPrivate() {
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

  const handlePlayVideo = () => {
    setIsVideoPlaying(true);
  };

  // Smooth scroll to #session-details
  const scrollToSessionDetails = () => {
    const detailsSection = document.getElementById("session-details");
    if (detailsSection) {
      detailsSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="tfd-select-private-v2">

      {/* ========== 1) FULLSCREEN HERO / VIDEO SECTION ========== */}
      <section className="fullscreen-video-section">
        {!isVideoPlaying ? (
          <div className="video-placeholder">
            <img
              src="/images/select/private-hero.jpg"
              alt="Private Sessions Hero"
              className="hero-bg-image"
            />
            <div className="overlay-dark" />

            {/* Play Button above everything */}
            <button className="play-button" onClick={handlePlayVideo}>
              &#9658;
            </button>

            {/* Centered Title & Subtitle, positioned slightly lower */}
            <div className="hero-text-centered">
              <h1>PRIVATE SESSIONS</h1>
            </div>
          </div>
        ) : (
          <div className="video-container">
            <video className="hero-video" autoPlay controls>
              <source
                src="https://www.w3schools.com/html/mov_bbb.mp4"
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>

            {/* Keep text visible, not blocking the play button anymore */}
            <div className="hero-text-centered">
              <h1>PRIVATE SESSIONS</h1>
              <p>Unlock your full potential with customized training</p>
            </div>
          </div>
        )}
      </section>

      {/* ========== 2) WHAT’S INCLUDED + 4 CARDS SECTION ========== */}
      <section className="whats-included-section">
        <div className="container-included">
          {/* Left Text */}
          <div className="included-text-wrapper">
            <h2>WHAT’S INCLUDED WITH OUR PRIVATE SESSIONS?</h2>
            <p>
              Looking to target specific areas of your game? Our Private
              Sessions—recommended by professionals—are popular, affordable, and
              adaptable to any skill level. Our proven methodologies challenge
              the <strong>Technical, Tactical, Physiological, and Psychological</strong>{" "}
              aspects of your game, ensuring you become a more complete player.
            </p>
            <ul className="bulleted-list">
              <li>Technical Conditioning</li>
              <li>Positional-Specific Training</li>
              <li>Tactical Understanding Development</li>
              <li>Technique / Biomechanical Refinement</li>
              <li>Mentoring &amp; Detailed Feedback</li>
              <li>And more!</li>
            </ul>
            <p>
              Experience some of the most advanced—and cost-effective—private
              training sessions in Australia.
            </p>
          </div>

          {/* Right: 4 Larger Cards */}
          <div className="cards-4-col">
            <div className="session-card one-on-one">
              <div className="session-card-overlay">
                <h3>1-ON-1</h3>
                <button
                  className="session-card-button discover"
                  onClick={scrollToSessionDetails}
                >
                  DISCOVER MORE &gt;
                </button>
              </div>
            </div>
            <div className="session-card two-on-one">
              <div className="session-card-overlay">
                <h3>2-ON-1</h3>
                <button
                  className="session-card-button discover"
                  onClick={scrollToSessionDetails}
                >
                  DISCOVER MORE &gt;
                </button>
              </div>
            </div>
            <div className="session-card three-on-one">
              <div className="session-card-overlay">
                <h3>3-ON-1</h3>
                <Link to="/contact" className="session-card-button enquire">
                  ENQUIRE TO KNOW MORE
                </Link>
              </div>
            </div>
            <div className="session-card four-on-one">
              <div className="session-card-overlay">
                <h3>4-ON-1</h3>
                <Link to="/contact" className="session-card-button enquire">
                  ENQUIRE TO KNOW MORE
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ========== 3) PACKAGES + TESTIMONIAL SECTION ========== */}
      <section className="packages-offer-section">
        <div className="packages-container">
          <h2 className="section-title">PACKAGES ON OFFER</h2>
          <div className="packages-content">
            {/* Left: 3 package cards with background images, no Book Now buttons */}
            <div className="packages-left">
              <div className="package-item package1-bg">
                <h3>1 x SESSION</h3>
              </div>
              <div className="package-item package5-bg">
                <h3>5 x SESSIONS</h3>
              </div>
              <div className="package-item package10-bg">
                <h3>10 x SESSIONS</h3>
              </div>
            </div>

            {/* Right: Testimonial */}
            <div className="packages-right">
              <p className="testimonial-text">
                Greg and his team are highly knowledgeable, passionate, and
                inspiring coaches. Their sessions include warm-ups, strength and
                conditioning, technical training, and consistent mental support.
                <br />
                <br />
                They also watch players’ Sunday games to provide extra feedback.
                If I could, I'd give them more than 5 stars. I can’t recommend
                them enough!
              </p>
              <p className="testimonial-author">
                ~ PARENT OF PROFESSIONAL ACADEMY JUNIOR PLAYER ~
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ========== 4) INVESTMENT BANNER SECTION ========== */}
      <section className="investment-section">
        <h2>
          THE GREATEST INVESTMENT YOU CAN MAKE IS IN YOURSELF AS A FOOTBALLER!
        </h2>
        <p>ARE YOU GIVING YOURSELF THE BEST CHANCE OF PROGRESSING?</p>
      </section>

      {/* ========== 5) SESSION DETAILS SECTION (1-on-1 / 2-on-1) ========== */}
      <section id="session-details" className="session-details-section">
        {/* 1-on-1 Info FIRST, above the table */}
        <div className="session-detail-wrapper">
          <div className="detail-text fadeIn">
            <h3>1-ON-1</h3>
            <p className="subtitle">1 Player : 1 Coach</p>
            <p>
              Work directly with an elite coach and enhance the specific areas
              of your game. Each specialized session is tailored to fit your
              personal needs, ensuring a proven pathway to success.
            </p>
          </div>

          {/* Table: bigger + fadeIn + added slideInUp */}
          <div className="fancy-packages-table fadeIn slideInUp">
            <h4 className="fancy-table-title">SESSION PACKAGES</h4>
            <div className="fancy-row fancy-header-row">
              <div className="fancy-col col-1session">1 SESSION</div>
              <div className="fancy-col col-5session">5 SESSIONS</div>
              <div className="fancy-col col-10session">10 SESSIONS</div>
            </div>

            <div className="fancy-row">
              <div className="fancy-col col-price">
                <p className="price-text">$90 <span>(ex. GST)</span></p>
                <p>PER SESSION</p>
              </div>
              <div className="fancy-col col-price">
                <p className="price-text">$85 <span>(ex. GST)</span></p>
                <p>PER SESSION</p>
              </div>
              <div className="fancy-col col-price">
                <p className="price-text">$80 <span>(ex. GST)</span></p>
                <p>PER SESSION</p>
              </div>
            </div>

            <div className="fancy-row">
              <div className="fancy-col col-desc">
                <p>An introduction to private sessions</p>
                <p>Valid for: 4 weeks from purchase</p>
                <p>Total session package: $99</p>
              </div>
              <div className="fancy-col col-desc">
                <p>5 private sessions with our elite qualified team</p>
                <p>Valid for: 12 weeks from purchase</p>
                <p>Total session package: $425</p>
              </div>
              <div className="fancy-col col-desc">
                <p>Progressive improvement & in-depth development</p>
                <p>Valid for: 20 weeks from purchase</p>
                <p>Total session package: $800</p>
              </div>
            </div>

            <div className="fancy-row fancy-bottom-row">
              <div className="fancy-col col-book">
                <button className="fancy-btn-book">BOOK NOW</button>
              </div>
              <div className="fancy-col col-save">
                <p>SAVE $25!</p>
              </div>
              <div className="fancy-col col-save">
                <p>SAVE $100!</p>
              </div>
            </div>

            <div className="fancy-row fancy-last-row">
              <div className="fancy-col col-book2">
                <button className="fancy-btn-book2">BOOK NOW</button>
              </div>
              <div className="fancy-col col-book2">
                <button className="fancy-btn-book2">BOOK NOW</button>
              </div>
              <div className="fancy-col col-book2">
                <button className="fancy-btn-book2">BOOK NOW</button>
              </div>
            </div>
          </div>
        </div>

        {/* 2-on-1 Info FIRST, above the table */}
        <div className="session-detail-wrapper">
          <div className="detail-text fadeIn">
            <h3>2-ON-1</h3>
            <p className="subtitle">2 Players : 1 Coach</p>
            <p>
              Enjoy semi-private training with a friend or teammate, benefiting
              from a coach’s undivided attention while fostering a
              collaborative environment to push each other further.
            </p>
          </div>

          {/* Another fancy table */}
          <div className="fancy-packages-table fadeIn slideInUp">
            <h4 className="fancy-table-title">SESSION PACKAGES</h4>
            <div className="fancy-row fancy-header-row">
              <div className="fancy-col col-1session">1 SESSION</div>
              <div className="fancy-col col-5session">5 SESSIONS</div>
              <div className="fancy-col col-10session">10 SESSIONS</div>
            </div>

            <div className="fancy-row">
              <div className="fancy-col col-price">
                <p className="price-text">$50 <span>(ex. GST)</span></p>
                <p>PER SESSION</p>
              </div>
              <div className="fancy-col col-price">
                <p className="price-text">$45 <span>(ex. GST)</span></p>
                <p>PER SESSION</p>
              </div>
              <div className="fancy-col col-price">
                <p className="price-text">$40 <span>(ex. GST)</span></p>
                <p>PER SESSION</p>
              </div>
            </div>

            <div className="fancy-row">
              <div className="fancy-col col-desc">
                <p>Intro to 2-on-1 sessions</p>
                <p>Valid for: 4 weeks from purchase</p>
                <p>Total session package: $100</p>
              </div>
              <div className="fancy-col col-desc">
                <p>5 sessions focusing on synergy for pairs</p>
                <p>Valid for: 12 weeks from purchase</p>
                <p>Total session package: $425</p>
              </div>
              <div className="fancy-col col-desc">
                <p>Comprehensive dev & synergy for two players</p>
                <p>Valid for: 20 weeks from purchase</p>
                <p>Total session package: $800</p>
              </div>
            </div>

            <div className="fancy-row fancy-bottom-row">
              <div className="fancy-col col-book">
                <button className="fancy-btn-book">BOOK NOW</button>
              </div>
              <div className="fancy-col col-save">
                <p>SAVE $25!</p>
              </div>
              <div className="fancy-col col-save">
                <p>SAVE $100!</p>
              </div>
            </div>

            <div className="fancy-row fancy-last-row">
              <div className="fancy-col col-book2">
                <button className="fancy-btn-book2">BOOK NOW</button>
              </div>
              <div className="fancy-col col-book2">
                <button className="fancy-btn-book2">BOOK NOW</button>
              </div>
              <div className="fancy-col col-book2">
                <button className="fancy-btn-book2">BOOK NOW</button>
              </div>
            </div>
          </div>
        </div>
      </section>
    <section className="new-testimonial-section">
      <div className="testimonial-container">
        <blockquote className="testimonial-quote">
          "Highly recommend Greg and his team! Very knowledgeable, highly accredited coaches and great young player mentors. Sessions are targeted and individualised, game specific and high in intensity and fun. FET knows and cares about every single one of their players. The rapport they build with young players and the positive, encouragement make all the difference. Great value for money training also."
        </blockquote>
        <p className="testimonial-author">~ Satisfied Parent of a Young Player ~</p>
      </div>
    </section>
    </div>
  );
}
